import { render, staticRenderFns } from "./LightboxPopUp.vue?vue&type=template&id=346138c6&scoped=true"
import script from "./LightboxPopUp.vue?vue&type=script&lang=js"
export * from "./LightboxPopUp.vue?vue&type=script&lang=js"
import style0 from "./LightboxPopUp.vue?vue&type=style&index=0&id=346138c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346138c6",
  null
  
)

export default component.exports